var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"button",staticClass:"d-print-none",class:{ visible: _vm.visible },attrs:{"id":"toTop","title":_vm.$t('Generic.toTop')},on:{"click":_vm.scrollToTop}},[_c('IconSvg',{attrs:{"filepath":"arrow-top.svg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }